import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from './kotlinx-atomicfu.mjs';
import {
  Long2qws0ah9gnpki as Long,
  Unit_instance104q5opgivhr8 as Unit_instance,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  Key_instance2d3ch37kcwr5h as Key_instance,
  getxe4seun860fg as get_0,
  minusKey2uxs00uz5ceqp as minusKey_0,
  releaseInterceptedContinuation17jnf0xkuoovi as releaseInterceptedContinuation,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  Result__exceptionOrNull_impl_p6xea91phgcskd46fkx as Result__exceptionOrNull_impl_p6xea9,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg1uwg4i093qaqh as _Result___get_value__impl__bjfvqg,
  printStackTrace18lnx7a39cni as printStackTrace,
  println2shhhgwwt4c61 as println,
  lazy2hsh8ze7j6ikd as lazy,
} from './kotlin-kotlin-stdlib.mjs';
import { FastArrayListw5fr1wlp4slq as FastArrayList } from './korlibs-korlibs-datastructure-core.mjs';
import {
  invokeOnTimeout3llts2igdsa63 as invokeOnTimeout,
  Delay9umexudtwyie as Delay,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class BaseLock {}
class Lock extends BaseLock {
  constructor() {
    super();
    this.h1o_1 = atomic$boolean$1(false);
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.i1o_1 = get_atomicfu$reentrantLock();
    this.j1o_1 = atomic$long$1(new Long(0, 0));
    this.k1o_1 = atomic$int$1(0);
  }
  l1o() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.lock' call
    this.i1o_1;
    this.k1o_1.atomicfu$incrementAndGet();
    this.j1o_1.kotlinx$atomicfu$value = Companion_getInstance_1().n1o();
  }
  o1o() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.unlock' call
    this.i1o_1;
    this.k1o_1.atomicfu$decrementAndGet();
  }
  p1o(unit) {
    if (!Companion_instance_0.q1o())
      throw UnsupportedOperationException.x7();
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.k1o_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.Lock.notify.<anonymous>' call
      var message = 'Must wait inside a synchronization block';
      throw IllegalStateException.w4(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.j1o_1.kotlinx$atomicfu$value.equals(Companion_getInstance_1().n1o())) {
      // Inline function 'korlibs.concurrent.lock.Lock.notify.<anonymous>' call
      var message_0 = 'Must lock the notify thread';
      throw IllegalStateException.w4(toString(message_0));
    }
    this.h1o_1.kotlinx$atomicfu$value = true;
  }
  r1o(unit, $super) {
    unit = unit === VOID ? Unit_instance : unit;
    var tmp;
    if ($super === VOID) {
      this.p1o(unit);
      tmp = Unit_instance;
    } else {
      var tmp_0 = $super.p1o;
      tmp = tmp_0.call(this, Unit_instance);
    }
    return tmp;
  }
}
class NonRecursiveLock extends BaseLock {
  constructor() {
    super();
    this.s1o_1 = atomic$int$1(0);
  }
  l1o() {
    if (Companion_getInstance_1().q1o()) {
      // Inline function 'korlibs.concurrent.thread.Companion.spinWhile' call
      Companion_getInstance_1();
      $l$loop: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.lock.<anonymous>' call
        if (!!this.s1o_1.atomicfu$compareAndSet(0, 1)) {
          break $l$loop;
        }
      }
    }
  }
  o1o() {
    if (Companion_getInstance_1().q1o()) {
      // Inline function 'korlibs.concurrent.thread.Companion.spinWhile' call
      Companion_getInstance_1();
      $l$loop: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.unlock.<anonymous>' call
        if (!!this.s1o_1.atomicfu$compareAndSet(1, 0)) {
          break $l$loop;
        }
      }
    }
  }
}
class Companion {
  q1o() {
    return Companion_getInstance_1().q1o();
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.t1o_1 = new PreferSyncIo(true);
    this.u1o_1 = new PreferSyncIo(false);
  }
  v1o(preferSyncIo) {
    return preferSyncIo === true ? this.t1o_1 : this.u1o_1;
  }
}
class PreferSyncIo {
  constructor(preferSyncIo) {
    Companion_getInstance_0();
    this.w1o_1 = preferSyncIo;
  }
  s1() {
    return Companion_getInstance_0();
  }
  toString() {
    return 'PreferSyncIo(preferSyncIo=' + this.w1o_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.w1o_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferSyncIo))
      return false;
    var tmp0_other_with_cast = other instanceof PreferSyncIo ? other : THROW_CCE();
    if (!(this.w1o_1 === tmp0_other_with_cast.w1o_1))
      return false;
    return true;
  }
}
class BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = BaseSignal$_init_$lambda_tuu04y;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    this.c1p_1 = onRegister;
    this.d1p_1 = FastArrayList.lx();
    this.e1p_1 = FastArrayList.lx();
    this.f1p_1 = 0;
  }
  g1p(once, handler) {
    this.c1p_1();
    var node = new Node(this, once, handler);
    this.d1p_1.f(node);
    return node;
  }
}
class Signal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = Signal$_init_$lambda_6vimhp;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  b1p(handler) {
    return this.g1p(false, handler);
  }
  h1p(handler) {
    return this.b1p(handler);
  }
  i1p(value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.d1p_1.f1()) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      try {
        this.f1p_1 = this.f1p_1 + 1 | 0;
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_0 = this.d1p_1;
        var n = 0;
        var m = 0;
        while (n < this_0.d1()) {
          if (m >= 0 && !(m === n)) {
            this_0.e3(m, this_0.c1(n));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var node = this_0.c1(n);
          var remove = node.j1p_1;
          // Inline function 'korlibs.io.async.Signal.invoke.<anonymous>' call
          node.k1p_1(value);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.d1() > m) {
          this_0.f3(this_0.d1() - 1 | 0);
        }
      }finally {
        this.f1p_1 = this.f1p_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.e1p_1.f1()) {
          // Inline function 'korlibs.io.async.fastIterateRemove' call
          var this_1 = this.e1p_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.d1()) {
            if (m_0 >= 0 && !(m_0 === n_0)) {
              this_1.e3(m_0, this_1.c1(n_0));
            }
            // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
            var it = this_1.c1(n_0);
            this.d1p_1.d3(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.d1() > m_0) {
            this_1.f3(this_1.d1() - 1 | 0);
          }
        }
      }
    }
    return tmp$ret$0;
  }
}
class AsyncSignal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = AsyncSignal$_init_$lambda_rsv6fb;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  q1p(handler) {
    return this.g1p(false, handler);
  }
  r1p(handler) {
    return this.q1p(handler);
  }
  s1p(value, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, value, $completion), $completion);
  }
}
class Node {
  constructor($outer, once, item) {
    this.l1p_1 = $outer;
    this.j1p_1 = once;
    this.k1p_1 = item;
  }
  z5() {
    if (this.l1p_1.f1p_1 > 0) {
      this.l1p_1.e1p_1.f(this);
    } else {
      this.l1p_1.d1p_1.d3(this);
    }
  }
}
class runBlockingNoSuspensions$1$context$1 extends AbstractCoroutineContextElement {
  static w1p($suspendCount, $box) {
    if ($box === VOID)
      $box = {};
    $box.v1p_1 = $suspendCount;
    var $this = this.tl(Key_instance, $box);
    $this.u1p_1 = Key_instance;
    return $this;
  }
  s1() {
    return this.u1p_1;
  }
  zc(continuation) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.async.<no name provided>.interceptContinuation.<anonymous>' call
    var _unary__edvuaz = this.v1p_1._v;
    this.v1p_1._v = _unary__edvuaz + 1 | 0;
    return continuation;
  }
  e15(timeMillis, continuation) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    continuation.nc(tmp$ret$0);
    return Unit_instance;
  }
}
class runBlockingNoSuspensions$1 {
  constructor($suspendCount, $resultEx, $completed, $rresult) {
    this.y1p_1 = $resultEx;
    this.z1p_1 = $completed;
    this.a1q_1 = $rresult;
    var tmp = this;
    tmp.x1p_1 = runBlockingNoSuspensions$1$context$1.w1p($suspendCount);
  }
  lc() {
    return this.x1p_1;
  }
  b1q(result) {
    var exception = Result__exceptionOrNull_impl_p6xea9(result);
    if (!(exception == null)) {
      this.y1p_1._v = exception;
      this.z1p_1._v = true;
      printStackTrace(exception);
    } else {
      // Inline function 'kotlin.getOrThrow' call
      throwOnFailure(result);
      var tmp = _Result___get_value__impl__bjfvqg(result);
      var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        _get_unitInstance__yoa8mq(this);
        var tmp_1 = Unit_instance;
        var tmp_2;
        if (!(Unit_instance == null)) {
          tmp_2 = Unit_instance;
        } else {
          tmp_2 = THROW_CCE();
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this.a1q_1._v = rvalue;
      this.z1p_1._v = true;
    }
  }
  nc(result) {
    return this.b1q(result);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    tmp.m1o_1 = lazy(NativeThread$Companion$warnSleep$delegate$lambda);
  }
  q1o() {
    return false;
  }
  n1o() {
    return new Long(1, 0);
  }
}
//endregion
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function Signal$_init_$lambda_6vimhp() {
  return Unit_instance;
}
function invoke(_this__u8e3s4) {
  return _this__u8e3s4.i1p(Unit_instance);
}
function *_generator_invoke__zhh2q8($this, value, $completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
    if ($this.d1p_1.f1()) {
      break $l$block;
    }
    try {
      $this.f1p_1 = $this.f1p_1 + 1 | 0;
      // Inline function 'korlibs.io.async.fastIterateRemove' call
      var this_0 = $this.d1p_1;
      var n = 0;
      var m = 0;
      while (n < this_0.d1()) {
        if (m >= 0 && !(m === n)) {
          this_0.e3(m, this_0.c1(n));
        }
        // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
        var node = this_0.c1(n);
        var remove = node.j1p_1;
        // Inline function 'korlibs.io.async.AsyncSignal.invoke.<anonymous>' call
        var tmp = node.k1p_1(value, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if (remove) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.d1() > m) {
        this_0.f3(this_0.d1() - 1 | 0);
      }
    }finally {
      $this.f1p_1 = $this.f1p_1 - 1 | 0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this.e1p_1.f1()) {
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_1 = $this.e1p_1;
        var n_0 = 0;
        var m_0 = 0;
        while (n_0 < this_1.d1()) {
          if (m_0 >= 0 && !(m_0 === n_0)) {
            this_1.e3(m_0, this_1.c1(n_0));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var it = this_1.c1(n_0);
          $this.d1p_1.d3(it);
          if (true) {
            m_0 = m_0 - 1 | 0;
          }
          n_0 = n_0 + 1 | 0;
          m_0 = m_0 + 1 | 0;
        }
        while (this_1.d1() > m_0) {
          this_1.f3(this_1.d1() - 1 | 0);
        }
      }
    }
  }
  return Unit_instance;
}
function AsyncSignal$_init_$lambda_rsv6fb() {
  return Unit_instance;
}
function BaseSignal$_init_$lambda_tuu04y() {
  return Unit_instance;
}
function runBlockingNoSuspensions(callback) {
  var completed = {_v: false};
  var rresult = {_v: null};
  var resultEx = {_v: null};
  var suspendCount = {_v: 0};
  startCoroutineUndispatched(callback, new runBlockingNoSuspensions$1(suspendCount, resultEx, completed, rresult));
  if (!completed._v)
    throw IllegalStateException.w4('runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
  if (!(resultEx._v == null))
    throw ensureNotNull(resultEx._v);
  var tmp;
  if (rresult._v == null) {
    throwUninitializedPropertyAccessException('rresult');
  } else {
    tmp = rresult._v;
  }
  return tmp;
}
function startCoroutineUndispatched(_this__u8e3s4, completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.startDirect' call
    var tmp;
    try {
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>' call
      // Inline function 'korlibs.io.async.withCoroutineContext' call
      completion.lc();
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>.<anonymous>' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(e));
        completion.nc(tmp$ret$3);
        break $l$block;
      } else {
        throw $p;
      }
    }
    var value = tmp;
    if (!(value === get_COROUTINE_SUSPENDED())) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
      var tmp$ret$6 = _Result___init__impl__xyqfz8(value_0);
      completion.nc(tmp$ret$6);
    }
  }
}
function _get_unitInstance__yoa8mq($this) {
  return Unit_instance;
}
function NativeThread$Companion$warnSleep$delegate$lambda() {
  println('!!! Sync sleeping on JS');
  return Unit_instance;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
//region block: post-declaration
initMetadataForClass(BaseLock, 'BaseLock');
initMetadataForClass(Lock, 'Lock', Lock);
initMetadataForClass(NonRecursiveLock, 'NonRecursiveLock', NonRecursiveLock);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
protoOf(PreferSyncIo).yc = get;
protoOf(PreferSyncIo).nl = fold;
protoOf(PreferSyncIo).ml = minusKey;
protoOf(PreferSyncIo).ol = plus;
initMetadataForClass(PreferSyncIo, 'PreferSyncIo', VOID, VOID, [Element]);
initMetadataForClass(BaseSignal, 'BaseSignal', VOID, VOID, VOID, [0]);
initMetadataForClass(Signal, 'Signal', Signal, VOID, VOID, [0]);
initMetadataForClass(AsyncSignal, 'AsyncSignal', AsyncSignal, VOID, VOID, [1, 0]);
initMetadataForClass(Node, 'Node', VOID, VOID, [AutoCloseable]);
protoOf(runBlockingNoSuspensions$1$context$1).yc = get_0;
protoOf(runBlockingNoSuspensions$1$context$1).ml = minusKey_0;
protoOf(runBlockingNoSuspensions$1$context$1).ad = releaseInterceptedContinuation;
protoOf(runBlockingNoSuspensions$1$context$1).f15 = invokeOnTimeout;
initMetadataForClass(runBlockingNoSuspensions$1$context$1, VOID, VOID, VOID, [AbstractCoroutineContextElement, ContinuationInterceptor, Delay], [1]);
initMetadataForClass(runBlockingNoSuspensions$1);
initMetadataForCompanion(Companion_1);
//endregion
//region block: init
Companion_instance_0 = new Companion();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance15h5aaybcsdep,
  Lock as Lock5n7hh3dgcidl,
  NonRecursiveLock as NonRecursiveLock2vf7fkhp857q,
  AsyncSignal as AsyncSignal3p186s2w7f15b,
  Signal as Signal3nnez3346azzf,
  invoke as invoke2sf88d1xeuyqh,
  runBlockingNoSuspensions as runBlockingNoSuspensions25hsuevf2mle,
};
//endregion
